export default function(response) {
    const {rateA = 0, rateB = 0, prevRateB = 0, prevRateA = 0} = response;

    return {
        ccyB: response.ccyB,
        ccyA: response.ccyA,
        rateB: response.rateB,
        rateA,
        rateC: rateA / rateB,
        prevRateB,
        prevRateA,
        id: response.ccyA + '-' + response.ccyB,
        date: 'now'
    };
}
